import React, { useState } from 'react';
import {
  Box,
  Paper,
  Grid,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Button,
  TextField,
  MenuItem
} from '@mui/material';
import {
  Download,
  PictureAsPdf,
  Assessment,
  Description,
  FileDownload,
  Search
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import Layout from '../components/layout/Cslayout';

const ReportPage = () => {
  const [reports] = useState([
    {
      id: 1,
      title: 'Annual Financial Report',
      type: 'Financial',
      date: '2025-01-15',
      status: 'Completed',
      size: '2.4 MB',
      format: 'PDF'
    },
    {
      id: 2,
      title: 'Board Meeting Minutes',
      type: 'Minutes',
      date: '2025-01-20',
      status: 'Pending',
      size: '1.8 MB',
      format: 'DOC'
    },
    {
      id: 3,
      title: 'Compliance Report',
      type: 'Compliance',
      date: '2025-01-25',
      status: 'In Review',
      size: '3.1 MB',
      format: 'PDF'
    }
  ]);

  const ReportStats = ({ title, value, icon, color }) => (
    <motion.div whileHover={{ scale: 1.02 }}>
      <Card sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ 
            p: 1.5, 
            borderRadius: 2, 
            bgcolor: `${color}15`,
            display: 'flex',
            alignItems: 'center'
          }}>
            {icon}
          </Box>
          <Box>
            <Typography color="text.secondary" variant="body2">{title}</Typography>
            <Typography variant="h5">{value}</Typography>
          </Box>
        </Box>
      </Card>
    </motion.div>
  );

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
            <Typography variant="h4">Reports</Typography>
            <Button variant="contained" startIcon={<FileDownload />}>
              Generate Report
            </Button>
          </Box>

          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={4}>
              <ReportStats
                title="Total Reports"
                value="45"
                icon={<Description sx={{ color: '#2196F3' }} />}
                color="#2196F3"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReportStats
                title="Generated This Month"
                value="12"
                icon={<Assessment sx={{ color: '#4CAF50' }} />}
                color="#4CAF50"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <ReportStats
                title="Pending Review"
                value="5"
                icon={<PictureAsPdf sx={{ color: '#FF9800' }} />}
                color="#FF9800"
              />
            </Grid>
          </Grid>

          <Paper sx={{ p: 2, mb: 4 }}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  placeholder="Search reports..."
                  InputProps={{
                    startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} />
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  defaultValue="all"
                  label="Report Type"
                >
                  <MenuItem value="all">All Types</MenuItem>
                  <MenuItem value="financial">Financial</MenuItem>
                  <MenuItem value="minutes">Minutes</MenuItem>
                  <MenuItem value="compliance">Compliance</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  select
                  fullWidth
                  defaultValue="all"
                  label="Status"
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="completed">Completed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="review">In Review</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Report Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Size</TableCell>
                    <TableCell>Format</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reports.map((report) => (
                    <TableRow key={report.id}>
                      <TableCell>{report.title}</TableCell>
                      <TableCell>
                        <Chip
                          label={report.type}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>{report.date}</TableCell>
                      <TableCell>
                        <Chip
                          label={report.status}
                          size="small"
                          color={
                            report.status === 'Completed' 
                              ? 'success' 
                              : report.status === 'Pending' 
                                ? 'warning' 
                                : 'default'
                          }
                        />
                      </TableCell>
                      <TableCell>{report.size}</TableCell>
                      <TableCell>{report.format}</TableCell>
                      <TableCell>
                        <IconButton>
                          <Download />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </motion.div>
      </Box>
    </Layout>
  );
};

export default ReportPage;